export default __webpack_public_path__ + "static/Owen-b7b50f1cb2d378bf2dfa757a1bc3e557.jpeg";